import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./globals.css";
import i18n from "./i18n";

function syncHtmlLang(lang: string) {
  if (typeof document !== "undefined") {
    document.documentElement.setAttribute("lang", lang);
  }
}
syncHtmlLang(i18n.language || "en");
i18n.on("languageChanged", syncHtmlLang);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
